<template>
  <footer
    v-show="showFooter"
    class="footer"
  >
    <div class="footer__inner row">
      <router-link
        v-for="(navItem, index) in navItems"
        :key="index"
        :to="navItem.to"
        tag="div"
        class="footer__link"
      >
        <component
          :is="navItem.icon"
          class="footer__icon"
        />
        <span class="footer__text p xsmall font-bold">{{ navItem.name }}</span>
      </router-link>
    </div>
  </footer>
</template>

<script>
import * as components from '@/icons'

export default {
  components: {
    ...components
  },
  data () {
    return {
      navItems: [{
        to: '/home',
        name: 'Home',
        icon: 'home'
      },{
        to: '/inside',
        name: 'Inside',
        icon: 'inside'
      },{
        to: '/outside',
        name: 'Outside',
        icon: 'Outside'
      },{
        to: '/settings',
        name: 'Settings',
        icon: 'settings'
      }]
    }
  },
  computed: {
    showFooter () {
      if (this.$store.state.onboarding.isOnboarding) {
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss">
  .footer {
    --safe-area-inset-bottom: env(safe-area-inset-bottom);
    --safe-area-inset-bottom: const(safe-area-inset-bottom);
    height: $page-footer-height;
    margin-top: $page-footer-margin-top;
    &__inner {
      position: fixed;
      bottom: 0;
      justify-content: space-between;
      width: 100%;
      max-width: 600px;
      background: $page-footer-background;
      padding: $page-footer-padding;
      z-index: 1;
      padding-bottom: calc(#{$page-footer-padding-bottom} + calc(env(safe-area-inset-bottom, 0px) + 0px)); // Need to test this
    }
    &__link {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      text-decoration: none;
      color: $page-footer-color;
      &.router-link-exact-active {
        color: $page-footer-color-active;
      }
    }
    &__icon {
      width: $hero-heading-icon-width;
      height: $hero-heading-icon-height;
    }
  }

</style>
